module.exports = __webpack_public_path__ + "static/img/z12.e0ca6b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/z12.png
// module id = HFjD
// module chunks = 0